import { render, staticRenderFns } from "./RetailerIcon.vue?vue&type=template&id=75f5b256&"
import script from "./RetailerIcon.vue?vue&type=script&lang=js&"
export * from "./RetailerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports